import request from './index';

export function list(params) {
  return request({
    params,
    method: 'GET',
    path: '/api/users/secretaries',
  });
}

export function create(body) {
  return request({
    body,
    method: 'POST',
    path: '/api/users/secretaries',
  });
}

export function remove(buildingId, userId) {
  return request({
    method: 'DELETE',
    path: `/api/users/secretaries/${buildingId}/${userId}`,
  });
}
